import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import TabClientes from './TabClientes';

export default function SidebarClientes(props) {
    const { cliente, setCliente, fixarCliente } = props;
    const [index, setIndex] = useState(0);
    
    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">CLIENTE: {cliente.razaosocial}</span>
        </div>
    );

    const sidebarStyle = {
        minWidth: props.isMobile ? '100%' : (index > 0 ? '70%' : '45%'),
        transition: 'all 0.5s ease-in-out',
        animation: props.cliente.idcliente ? 'fadeInSidebar 0.3s ease-out' : ''
    };

    return (
        <Sidebar 
            onHide={() => {
                setCliente([]);
                setIndex(0);
                props.setSideBarOpened(false)
            }}
            
            header={customHeader} 
            visible={cliente.idcliente} 
            style={sidebarStyle} 
            position="right" 
            className="custom-sidebar"
            {...props}
        >
            <TabClientes setIndex={setIndex} {...props}  fixarCliente ={fixarCliente}/>                            
        </Sidebar>
    );
}
